module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DSelect', {
    attrs: {
      "items": _vm.usersAndTags,
      "isLoading": _vm.isLoading,
      "itemsSelected": _vm.selectedUsers,
      "show": _vm.showDropDown,
      "allDataLoaded": _vm.allDataLoaded,
      "multiple": _vm.multiple
    },
    on: {
      "add": _vm.addUser,
      "remove": _vm.removeUser,
      "show": _vm.setShow,
      "update": _vm.setSelectedUsers,
      "searchText": _vm.setCreateUserText
    },
    scopedSlots: _vm._u([{
      key: "item_identifier",
      fn: function(props) {
        return [_vm._t("default", null, {
          "slot": "item_identifier",
          "userId": props.userId
        })]
      }
    }], null, true)
  }, [_vm._v(" "), (_vm.showCreateButton) ? _c('template', {
    slot: "noMatch"
  }, [_c('h4', [_c('span', {
    staticClass: "marg-10-right pad-10"
  }, [_vm._v(_vm._s(_vm.$t('vue2.dselect.no_matching_results')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-blue bttn-inline",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCalendarOnDSelect.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.dselect.create_user')) + "\n        ")])])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f06f80e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectUsers.vue
// module id = 1844
// module chunks = 1